import { Component, OnInit, Input } from '@angular/core';
import { Cahier } from 'src/app/data/habilitation/models/cahier.model';
import { AbstractRechercheItemComponent } from '../abstract-recherche-items.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { CahiersService } from 'src/app/data/commission/services/cahiers/cahiers.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';

@Component({
    selector: 'app-recherche-cdcs',
    templateUrl: './recherche-cdcs.component.html',
    styleUrls: ['./recherche-cdcs.component.scss'],
    standalone: false
})
export class RechercheCdcsComponent extends AbstractRechercheItemComponent<Cahier> implements OnInit {
    @Input() idOrganisme: number;
    @Input() alreadySelectedCahiersIds: number[];

    constructor(public readonly modal: NgbActiveModal, private readonly cahiersService: CahiersService, private readonly loaderService: LoaderService) {
        super(modal);
    }

    getData() {
        return this.cahiersService.getCahiers().pipe(
            this.loaderService.operator(),
            map(cahiers => {
                return cahiers.filter(cahier => this.alreadySelectedCahiersIds.indexOf(cahier.id) === -1);
            })
        );
    }

    selectAll() {
        this.items.forEach(item => {
            if (!item.disabled && !item.selected) {
                this.toggleSelectionItem(item);
            }
        });
    }
    toggleSelectionItem(item: any) {
        if (!item.disabled) {
            item.selected = !item.selected;
        }
    }
}
